import React from 'react';
import clsx from 'clsx';

import Img from '@common/Image';
import Link from '@common/Link';

const ImageTextOverlay = ({ to, image, className, colour, children, aspectRatio = '5 / 6', ...other }) => {
  return (
    <Link
      to={to}
      className={clsx('d-flex flex-column position-relative scale-1-img', className)}
      {...other}
      >
      <div className='overflow-hidden rounded'>
        {image &&
          <Img
            loading='eager'
            image={image.gatsbyImageData}
            file={image.file}
            alt={image.description}
            style={{aspectRatio: aspectRatio}}
          />
        }
      </div>
      <div className={clsx('d-flex flex-column align-items-start justify-content-end p-3 bg-white text-black rounded', {[`border-${colour}`]:colour})}
      style={{
        margin: '-75px 10px 0',
        border: '3px solid',
        zIndex: 99
      }}>
        {children}
      </div>
    </Link>
  )
}

export default ImageTextOverlay
